import {
	SCHEDULE_ACTION_TYPES,
	ScheduleAction,
	SCHEDULE_TASKS_FILTER_VALUES,
	ScheduleTasks,
} from './../../../../types/schedule'
import { CreateTaskData } from './../../../../types/task'
import { AppThunkAction } from '../../../index'
import { executeResponseError } from '../../../../helpers'
import api from '../../../../api'

export const setTasks = (tasks: ScheduleTasks): AppThunkAction => {
	return dispatch => {
		dispatch({
			type: SCHEDULE_ACTION_TYPES.SCHEDULE_TASKS_GET,
			payload: tasks,
		})
	}
}

export const setFilterValue = (
	filterValue: SCHEDULE_TASKS_FILTER_VALUES
): AppThunkAction => {
	return dispatch => {
		dispatch({
			type: SCHEDULE_ACTION_TYPES.SCHEDULE_TASKS_SET_FILTER,
			payload: filterValue,
		})
	}
}

export const makeRequestToChangeTaskStatus = (
	taskId: string,
	status: string
): AppThunkAction<Promise<void>> => {
	return async () => {
		try {
			await api.task.updateTask(taskId, {
				'settings.status': status,
			})
		} catch (e: any) {
			const error = executeResponseError(e, 'Update status task error.')

			throw new Error(error || '')
		}
	}
}

export const editTask = (
	taskId: string,
	data: object
): AppThunkAction<Promise<void>> => {
	return async () => {
		try {
			await api.task.updateTask(taskId, data)
		} catch (e: any) {
			const error = executeResponseError(e, 'Update task error.')

			throw new Error(error || '')
		}
	}
}

export const setDoneStatusForTask = (
	id: string,
	status: string
): AppThunkAction => {
	return dispatch => {
		dispatch({
			type: SCHEDULE_ACTION_TYPES.SCHEDULE_TASKS_SET_DONE_STATUS_FOR_TASK,
			payload: {
				id,
				status,
			},
		})
	}
}

export const taskDelete = (taskId: string): AppThunkAction<Promise<void>> => {
	return async dispatch => {
		try {
			await api.task.deleteTask(taskId)

			dispatch({
				type: SCHEDULE_ACTION_TYPES.SCHEDULE_TASKS_DELETE_TASK,
				payload: taskId,
			})
		} catch (e: any) {
			const error = executeResponseError(e, 'Get schedule error')

			throw new Error(error || '')
		}
	}
}

export const createTask = (
	data: CreateTaskData
): AppThunkAction<Promise<void>> => {
	return async () => {
		try {
			await api.task.create(data)

			// todo: need add to store returned value. Need updated returned result (Ron)
		} catch (e: any) {
			const error = executeResponseError(e, 'Get schedule error')

			throw new Error(error || '')
		}
	}
}

export const getTaskList = (): AppThunkAction<Promise<void>> => {
	return async dispatch => {
		try {
			const res = await api.task.getTasks()

			dispatch(setTasks(res.data.result))
		} catch (e: any) {
			const error = executeResponseError(e, 'Get tasks error.')

			throw new Error(error || '')
		}
	}
}

export const selectTask = (
	taskId: string
): AppThunkAction<void, ScheduleAction> => {
	return dispatch => {
		dispatch({
			type: SCHEDULE_ACTION_TYPES.SCHEDULE_TASK_SELECT,
			payload: taskId,
		})
	}
}

export const unselectTask = (
	taskId: string
): AppThunkAction<void, ScheduleAction> => {
	return dispatch => {
		dispatch({
			type: SCHEDULE_ACTION_TYPES.SCHEDULE_TASK_UNSELECT,
			payload: taskId,
		})
	}
}

export const selectAllTask = (): AppThunkAction<void, ScheduleAction> => {
	return dispatch => {
		dispatch({
			type: SCHEDULE_ACTION_TYPES.SCHEDULE_TASK_SELECT_ALL,
		})
	}
}

export const unselectAllTasks = (): AppThunkAction<void, ScheduleAction> => {
	return dispatch => {
		dispatch({
			type: SCHEDULE_ACTION_TYPES.SCHEDULE_TASK_UNSELECT_ALL,
		})
	}
}

export const setTaskTypes = (types: string[]): AppThunkAction => {
	return dispatch => {
		dispatch({
			type: SCHEDULE_ACTION_TYPES.SET_TASK_TYPES,
			payload: types,
		})
	}
}

export const setTaskPriorities = (priorities: string[]): AppThunkAction => {
	return dispatch => {
		dispatch({
			type: SCHEDULE_ACTION_TYPES.SET_TASK_PRIORITIES,
			payload: priorities,
		})
	}
}

export const setTaskStatuses = (statuses: string[]): AppThunkAction => {
	return dispatch => {
		dispatch({
			type: SCHEDULE_ACTION_TYPES.SET_TASK_STATUSES,
			payload: statuses,
		})
	}
}
export const setTaskAccounts = (accounts: string[]): AppThunkAction => {
	return dispatch => {
		dispatch({
			type: SCHEDULE_ACTION_TYPES.SET_TASK_ACCOUNTS,
			payload: accounts,
		})
	}
}

export const setTaskSearch = (searchString: string): AppThunkAction => {
	return dispatch => {
		dispatch({
			type: SCHEDULE_ACTION_TYPES.SET_TASK_SEARCH,
			payload: searchString,
		})
	}
}
